import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { CheckCircle2, Plus, Pencil, Trash2, Clock, Package } from "lucide-react";

export const TasksListCard = ({ order, totals, onToggleTask, onEditTask, onDeleteTask, onAddTask }) => {
  const tasks = order?.tasks || [];
  return (
    <Card data-testid="detail-tasks-card">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base flex items-center gap-2">
            <CheckCircle2 className="w-5 h-5 text-orange-600" />
            Aufgaben ({totals.completedTasks}/{totals.totalTasks})
          </CardTitle>
          <Button size="sm" onClick={onAddTask} className="gap-2" data-testid="detail-add-task-btn">
            <Plus className="w-4 h-4" />Aufgabe
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {tasks.length > 0 ? (
          <div className="space-y-3">
            {tasks.map((task) => (
              <div
                key={task.id}
                className={`p-3 rounded-lg border ${
                  task.completed ? 'bg-green-50 border-green-200' : 'bg-white border-gray-200'
                }`}
                data-testid="detail-task-row"
              >
                <div className="flex items-start gap-3">
                  <Checkbox
                    checked={task.completed}
                    onCheckedChange={() => onToggleTask(task.id, task.completed)}
                    className="mt-1"
                    data-testid="detail-task-checkbox"
                  />
                  <div className="flex-1 min-w-0">
                    <p className={`font-medium ${task.completed ? 'line-through text-muted-foreground' : ''}`}>
                      {task.description}
                    </p>
                    {task.time_minutes > 0 && (
                      <span className="flex items-center gap-1 text-xs text-muted-foreground mt-1">
                        <Clock className="w-3 h-3" />{task.time_minutes} min
                      </span>
                    )}
                    {task.materialien && task.materialien.length > 0 && (
                      <div className="mt-2 space-y-1">
                        {task.materialien.map((m, idx) => (
                          <div key={idx} className="text-xs bg-slate-100 p-2 rounded flex items-center gap-2 flex-wrap">
                            <Package className="w-3 h-3 text-muted-foreground" />
                            <span className="font-medium">{m.bezeichnung}</span>
                            {m.anzahl && <span>({m.anzahl} {m.einheit || 'Stück'})</span>}
                            {m.artikelnummer && <span className="text-muted-foreground">Art.Nr: {m.artikelnummer}</span>}
                            {m.material_id && <span className="text-amber-700 text-[10px]">• reserviert</span>}
                            {m.kosten > 0 && <span className="text-green-700 ml-auto">{parseFloat(m.kosten).toFixed(2)} €</span>}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="flex gap-1 shrink-0">
                    <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => onEditTask(task)} data-testid="detail-edit-task-btn">
                      <Pencil className="w-4 h-4" />
                    </Button>
                    <Button variant="ghost" size="icon" className="h-8 w-8 text-destructive" onClick={() => onDeleteTask(task.id)} data-testid="detail-delete-task-btn">
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center text-muted-foreground py-4">Keine Aufgaben vorhanden</p>
        )}
      </CardContent>
    </Card>
  );
};
